import apiFetch from '@wordpress/api-fetch';
import { registerStore } from '@wordpress/data';


/**
 * Actions
 */
const actions = {
	setTaxonomiesList( taxonomiesList ) {
		return {
			type: 'SET_TAXONOMIES_LIST',
			taxonomiesList,
		};
	},
    getTaxonomiesList( path ) {
		return {
			type: 'GET_TAXONOMIES_LIST',
			path,
		};
	},
    setSelectionGeojson( selectionGeojson ) {
		return {
			type: 'SET_SELECTION_GEOJSON',
			selectionGeojson,
		};
	},
    getSelectionGeojson( path ) {
		return {
			type: 'GET_SELECTION_GEOJSON',
			path,
		};
	},
    setSelectionsList( selectionsList ) {
		return {
			type: 'SET_SELECTION_LIST',
			selectionsList,
		};
	},
    getSelectionsList( path ) {
		return {
			type: 'GET_SELECTION_LIST',
			path,
		};
	},
    setApidaePostTypeList( ApidaePostTypeList ) {
		return {
			type: 'SET_POST_TYPE_LIST',
			ApidaePostTypeList,
		};
	},
    getApidaePostTypeList( path ) {
		return {
			type: 'GET_POST_TYPE_LIST',
			path,
		};
	},
    setCardsTemplatesList( CardsTemplatesList ) {
		return {
			type: 'SET_CARDS_TEMPLATES_LIST',
			CardsTemplatesList,
		};
	},
    getCardsTemplatesList( path ) {
		return {
			type: 'GET_CARDS_TEMPLATES_LIST',
			path,
		};
	},
};


/**
 * Reducer
 *
 * @param {object} state
 * @param {string} action
 */
function reducer( state = { selectionGeojson: {},taxonomiesList: {}, selectionsList:{}, ApidaePostTypeList:{}, CardsTemplatesList:{} }, action ) {
    switch ( action.type ) {
        case 'SET_TAXONOMIES_LIST': {
            return {
                ...state,
                taxonomiesList: action.taxonomiesList,
            };
        }
        case 'SET_SELECTION_GEOJSON': {
            return {
                ...state,
                selectionGeojson: action.selectionGeojson,
            };
        }
        case 'SET_SELECTION_LIST': {
            return {
                ...state,
                selectionsList: action.selectionsList,
            };
        }
        case 'SET_POST_TYPE_LIST': {
            return {
                ...state,
                ApidaePostTypeList: action.ApidaePostTypeList,
            };
        }
        case 'SET_CARDS_TEMPLATES_LIST': {
            return {
                ...state,
                CardsTemplatesList: action.CardsTemplatesList,
            };
        }
        default:{
            return state;
        }
    }
};


/**
 * Selectors
 */
const selectors = {
    getTaxonomiesList( state ) {
        const { taxonomiesList } = state;
        return taxonomiesList;
    },
    getSelectionGeojson( state ) {
        const { selectionGeojson } = state;
        return selectionGeojson;
    },
    getSelectionsList( state ) {
        const { selectionsList } = state;
        return selectionsList;
    },
    getApidaePostTypeList( state ) {
        const { ApidaePostTypeList } = state;
        return ApidaePostTypeList;
    },
    getCardsTemplatesList( state ) {
        const { CardsTemplatesList } = state;
        return CardsTemplatesList;
    },
};

/**
 * Controls
 */
const controls = {
    GET_TAXONOMIES_LIST( action ) {
        return apiFetch( { path: action.path } );
    },
    GET_SELECTION_GEOJSON( action ) {
        return apiFetch( { path: action.path } );
    },
    GET_SELECTION_LIST( action ) {
        return apiFetch( { path: action.path } );
    },
    GET_POST_TYPE_LIST( action ) {
        return apiFetch( { path: action.path } );
    },
    GET_CARDS_TEMPLATES_LIST( action ) {
        return apiFetch( { path: action.path } );
    },
};

/**
 * Resolvers
 */
const resolvers = {
    *getTaxonomiesList( optionKey ) {
        const taxonomiesList = yield actions.getTaxonomiesList(
            '/wp-dae/v1/get/commontaxonomies/' + optionKey + '/',
        );
        return actions.setTaxonomiesList( taxonomiesList );
    },
    *getSelectionGeojson( optionKey ) {
        const selectionGeojson = yield actions.getSelectionGeojson(
            '/wp-dae/v1/get/geojson/' + optionKey + '/',
        );
        return actions.setSelectionGeojson( selectionGeojson );
    },
    *getSelectionsList() {
        const selectionsList = yield actions.getSelectionsList(
            '/wp-dae/v1/get/getimportedselections/',
        );
        return actions.setSelectionsList( selectionsList );
    },
    *getApidaePostTypeList() {
        const ApidaePostTypeList = yield actions.getApidaePostTypeList(
            '/wp-dae/v1/get/getposttypelist/',
        );
        return actions.setApidaePostTypeList( ApidaePostTypeList );
    },
    *getCardsTemplatesList() {
        const CardsTemplatesList = yield actions.getCardsTemplatesList(
            '/wp-dae/v1/get/getcardstemplates/',
        );
        return actions.setCardsTemplatesList( CardsTemplatesList );
    },
};




/**
 * Register Store
 */
const store = registerStore(
    'wpdae/data',
    {
        actions,
        controls,
        reducer,
        resolvers,
        selectors,
    }
);

export default store;
